import { Text, CustomLink } from 'components/common'

const Location = ({ location, isMyProfile }) => {
    return (
        <Text tag={'h6'} className={'const14 place PopReg darkGrey'} >
            {(location?.city && location?.country)
                ? `${location?.city}, ${location?.country}`
                : (!location?.city && !location?.country && isMyProfile)
                && <CustomLink url={`/profile/edit`}>Update location</CustomLink>}
            {(!location?.city && location?.country) && (
                `${location.country}`
            )}
            {(location?.city && !location?.country) && (
                `${location.city}`
            )}
        </Text>
    )
}

export default Location